import React from "react";
import "../../css/components/Footer.css";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/ThePlanLogo.png";

function Footer() {
  const navigate = useNavigate();
  return (
    <footer id="contact">
      <div className="footer dark footer-legal column">
        <div className="header-logo">
          <img src={Logo} alt="The Plan Logo" />
        </div>
        <div className="title grey">
          No hard sell. No pressure. Just an honest conversation about where you
          are and where you want to be. Relevant to every rank, every role,
          every stage of service.
        </div>
      </div>
      <div className="footer">
        <div className="footer-legal">
          <div className="title grey" style={{ marginBottom: "20px" }}>
            The Plan UK is a trading style of EDWARDCOOMBS LTD is an Appointed
            Representative of Rosemount Financial Solutions (IFA) Limited which
            is authorised and regulated by the Financial Conduct Authority.
            Rosemount Financial Solutions (IFA) Limited is entered on the
            Financial Services Register under reference 535515.
          </div>
          <div className="title grey">
            EDWARDCOOMBS LTD is registered in England and Wales (Company Number:
            16407001). Registered Address: 71-75 Shelton Street, Covent Garden,
            London, United Kingdom, WC2H 9JQ. The information on this website is
            subject to the UK regulatory regime and is intended for consumers in
            the UK.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
